export interface ITickRules {
  StartTickPriceRange?: number// 1206
  EndTickPriceRange?: number// 1207
  TickIncrement?: number// 1208
  TickRuleType?: number// 1209
  TickRuleProductComplex?: string// 2571
  SettlPriceIncrement?: number// 1830
  SettlPriceSecondaryIncrement?: number// 1831
}
